import { RagChip } from "@/components/ui/rag";

export function ReportEvidenceLists({ items, shortNote, accent = "red", emptyLabel }) {
  const bar = accent === "red" ? "bg-destructive" : "bg-warning";
  if (!items || items.length === 0) {
    return (
      <p className="rounded-sm border border-dashed border-border bg-card px-4 py-3 text-sm text-muted-foreground">
        {emptyLabel}
      </p>
    );
  }
  return (
    <div className="overflow-hidden rounded-sm border border-border bg-card">
      <ul className="divide-y divide-border">
        {items.map((item) => (
          <li key={item.id} className="flex items-start gap-3 px-4 py-3">
            <span className={`mt-1.5 block h-2 w-2 shrink-0 rounded-full ${bar}`} />
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  {String(item.number).padStart(2, "0")} · {item.domain}
                </span>
                <span className="font-display text-[15px] font-medium leading-tight text-foreground">
                  {item.title}
                </span>
                <RagChip rag={item.rag} className="ml-auto">{item.shortLabel}</RagChip>
              </div>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{shortNote(item)}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
